import React, { useCallback } from 'react';

import classnames from 'classnames';
import { InfoTooltip } from '@bringg-frontend/ui';

import './input-label-with-tooltip.scss';

type InputLabelWithTooltipProps = {
	id: string;
	title: string;
	className?: string;
	tooltip?: string;
	required?: boolean;
	containerId?: string;
};

const InputLabelWithTooltip = ({
	id,
	title,
	tooltip,
	className,
	required = false,
	containerId
}: InputLabelWithTooltipProps) => {
	const wrapperIdText = containerId ? `${containerId}-${id}` : `${id}`;
	const wrapperId = `optimization-configuration-input-${wrapperIdText}-label`;
	const getPopupContainer = useCallback(() => document.getElementById(wrapperId), [wrapperId]);

	return (
		<div id={wrapperId} className={classnames('optimization-configuration-input-label-with-tooltip', className)}>
			<span className={classnames('input-title', { 'required-field': required })}>{title}</span>
			{tooltip && <InfoTooltip title={tooltip} placement="right" getPopupContainer={getPopupContainer} />}
		</div>
	);
};

export default InputLabelWithTooltip;
